import React from "react";
import { getLocalTime, handlingAppName } from "../../helpers/helpers";
type AppProps = {
  count?: number;
  appName?: string;
};
type MoreTableProps = {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  organization: string;
  role: string;
  country: string;
  email: string;
  createdDate: string;
  apps: AppProps[];
};
type RowProps = {
  row: MoreTableProps;
};

const MoreTable = (props: RowProps) => {
  const { row } = props;
  return (
    <div className="relativeorder rounded-sm w-full p-4 lg:flex justify-between lg:space-x-2 space-y-2 lg:space-y-0">
      <div className="w-full lg:w-1/2 border p-2 shadow-md leading-7">
        <div className="flex space-x-2">
          <div className="w-1/2 font-semibold text-sky-900"> Email</div>
          <div> {row.email}</div>
        </div>
        <div className="flex space-x-2">
          <div className="w-1/2 font-semibold text-sky-900"> Phone</div>
          <div> {row.phone}</div>
        </div>
        <div className="flex space-x-2">
          <div className="w-1/2 font-semibold text-sky-900"> Organization</div>
          <div> {row.organization}</div>
        </div>
        <div className="flex space-x-2">
          <div className="w-1/2 font-semibold text-sky-900"> Role</div>
          <div> {row.role}</div>
        </div>
        <div className="flex space-x-2">
          <div className="w-1/2 font-semibold text-sky-900"> Created Date</div>
          <div>
            {getLocalTime(row.createdDate)} {}
          </div>
        </div>
        <div className="flex space-x-2">
          <div className="w-1/2 font-semibold text-sky-900"> Country</div>
          <div> {row.country}</div>
        </div>
      </div>
      <table className="overflow-x-auto w-full lg:w-1/2 h-fit p-2 border rounded-sm shadow-md uppercase">
        <tr className="font-semibold text-white bg-sky-700 p-2">
          <th className={`px-2 py-1`}>Application Name</th>
          <th className={`px-2 py-1`}>No Of Times Visited</th>
        </tr>
        {row?.apps?.length > 0 ? (
          row.apps?.map((item: AppProps, _i: number) => {
            return (
              <tr key={item.appName} className="w-full h-8">
                <td className={`px-2 py-1`}>{handlingAppName(item.appName)}</td>
                <td className={`px-2 py-1`}>{item.count}</td>
              </tr>
            );
          })
        ) : (
          <div className="p-2">No records found!</div>
        )}{" "}
      </table>
    </div>
  );
};

export default MoreTable;
